import type { ElementType } from 'react';
import AboutSatsPage from '../client/pages/about-sats-page/about-sats-page';
import ArticlePage from '../client/pages/article-page/article-page';
import ArticlesCategoryPage from '../client/pages/articles-category-page/articles-category-page';
import ArticlesSubcategoryPage from '../client/pages/articles-subcategory-page/articles-subcategory-page';
import AutomaticLogoutPage from '../client/pages/automatic-logout-page/automatic-logout-page';
import BootCampConceptPage from '../client/pages/boot-camp-concept-page/boot-camp-concept-page';
import BootCampConceptsLandingPage from '../client/pages/boot-camp-concepts-landing-page/boot-camp-concepts-landing-page';
import BootCampEventPage from '../client/pages/boot-camp-event-page/boot-camp-event-page';
import BootCampLandingPage from '../client/pages/boot-camp-landing-page/boot-camp-landing-page';
import BootCampShop from '../client/pages/boot-camp-shop/boot-camp-shop';
import BootCampShopConfirmation from '../client/pages/boot-camp-shop-confirmation/boot-camp-shop-confirmation';
import BootCampShopError from '../client/pages/boot-camp-shop-error/boot-camp-shop-error';
import BootCampShopPay from '../client/pages/boot-camp-shop-pay/boot-camp-shop-pay';
import BootCampShopStatus from '../client/pages/boot-camp-shop-status/boot-camp-shop-status';
import BringAFriend from '../client/pages/bring-a-friend/bring-a-friend';
import ClubPage from '../client/pages/club-page/club-page';
import ClubsOverviewPage from '../client/pages/clubs-overview-page/clubs-overview-page';
import ClubsRegionOverviewPage from '../client/pages/clubs-region-overview-page/clubs-region-overview-page';
import ContactFormStep from '../client/pages/contact-form-step/contact-form-step';
import ContactFormTerminus from '../client/pages/contact-form-terminus/contact-form-terminus';
import ContentBlockPreview from '../client/pages/content-block-preview/content-block-preview';
import CorporateArticlePage from '../client/pages/corporate-article-page/corporate-article-page';
import CorporateMembershipPage from '../client/pages/corporate-membership-page/corporate-membership-page';
import CorporateSub from '../client/pages/corporate-sub/corporate-sub';
import ErrorPage from '../client/pages/error-page/error-page';
import ExercisePage from '../client/pages/exercise-page/exercise-page';
import GroupExerciseBookingPage from '../client/pages/group-exercise-booking-page/group-exercise-booking-page';
import GroupExercisePage from '../client/pages/group-exercise-page/group-exercise-page';
import HeroPreview from '../client/pages/hero-preview/hero-preview';
import InspirationalArticlePage from '../client/pages/inspirational-article-page/inspirational-article-page';
import LandingPage from '../client/pages/landing-page/landing-page';
import LinkBoxListPage from '../client/pages/link-box-list-page/link-box-list-page';
import LinksBlockPreview from '../client/pages/links-block-preview/links-block-preview';
import ListPage from '../client/pages/list-page/list-page';
import ListPreview from '../client/pages/list-preview/list-preview';
import LoginPage from '../client/pages/login-page/login-page';
import MagazinePage from '../client/pages/magazine-page/magazine-page';
import MarketingLandingPage from '../client/pages/marketing-landing-page/marketing-landing-page';
import MarketingSubpage from '../client/pages/marketing-subpage/marketing-subpage';
import MemberCareArticlePage from '../client/pages/member-care-article-page/member-care-article-page';
import MemberCareCategoryPage from '../client/pages/member-care-category-page/member-care-category-page';
import MemberCarePage from '../client/pages/member-care-page/member-care-page';
import MemberCareSubcategoryPage from '../client/pages/member-care-subcategory-page/member-care-subcategory-page';
import NotFoundPage from '../client/pages/not-found-page/not-found-page';
import PersonalTrainerLandingPage from '../client/pages/personal-trainer-landing-page/personal-trainer-landing-page';
import PersonalTrainerSelectSessionPage from '../client/pages/personal-trainer-select-session-page/personal-trainer-select-session-page';
import PersonalTrainerSessionPaymentPage from '../client/pages/personal-trainer-session-payment-page/personal-trainer-session-payment-page';
import PersonalTrainerSessionShopConfirmationPage from '../client/pages/personal-trainer-session-shop-confirmation-page/personal-trainer-session-shop-confirmation-page';
import PersonalTrainerSessionShopErrorPage from '../client/pages/personal-trainer-session-shop-error-page/personal-trainer-session-shop-error-page';
import Press from '../client/pages/press/press';
import PressArticle from '../client/pages/press-article/press-article';
import ProfileFilterPage from '../client/pages/profile-filter-page/profile-filter-page';
import ProfilePage from '../client/pages/profile-page/profile-page';
import ProfilingQuestionnaireConfirmationPage from '../client/pages/profiling-questionnaire-confirmation-page/profiling-questionnaire-confirmation-page';
import ProfilingQuestionnairePage from '../client/pages/profiling-questionnaire-page/profiling-questionnaire-page';
import Redirect from '../client/pages/redirect/redirect';
import Region from '../client/pages/region/region';
import ResetPasswordPage from '../client/pages/reset-password-page/reset-password-page';
import SalesPoster from '../client/pages/sales-poster/sales-poster';
import SalesPosters from '../client/pages/sales-posters/sales-posters';
import SetPasswordPage from '../client/pages/set-password-page/set-password-page';
import ShowcasePreview from '../client/pages/showcase-preview/showcase-preview';
import TermsAndConditionsListPage from '../client/pages/terms-and-conditions-list-page/terms-and-conditions-list-page';
import VideoBlockPreview from '../client/pages/video-block-preview/video-block-preview';
import WaitingArea from '../client/pages/waiting-area/waiting-area';
import WebAdmin from '../client/pages/web-admin/web-admin';
import WebAdminContentTypes from '../client/pages/web-admin-content-types/web-admin-content-types';
import WebAdminData from '../client/pages/web-admin-data/web-admin-data';
import WebAdminLogin from '../client/pages/web-admin-login/web-admin-login';
import WebAdminSettings from '../client/pages/web-admin-settings/web-admin-settings';
import WebAdminSitemap from '../client/pages/web-admin-sitemap/web-admin-sitemap';

/** This object is automatically generated. */
export const pageComponents: Record<string, ElementType> = {
  AboutSatsPage,
  ArticlePage,
  ArticlesCategoryPage,
  ArticlesSubcategoryPage,
  AutomaticLogoutPage,
  BootCampConceptPage,
  BootCampConceptsLandingPage,
  BootCampEventPage,
  BootCampLandingPage,
  BootCampShop,
  BootCampShopConfirmation,
  BootCampShopError,
  BootCampShopPay,
  BootCampShopStatus,
  BringAFriend,
  ClubPage,
  ClubsOverviewPage,
  ClubsRegionOverviewPage,
  ContactFormStep,
  ContactFormTerminus,
  ContentBlockPreview,
  CorporateArticlePage,
  CorporateMembershipPage,
  CorporateSub,
  ErrorPage,
  ExercisePage,
  GroupExerciseBookingPage,
  GroupExercisePage,
  HeroPreview,
  InspirationalArticlePage,
  LandingPage,
  LinkBoxListPage,
  LinksBlockPreview,
  ListPage,
  ListPreview,
  LoginPage,
  MagazinePage,
  MarketingLandingPage,
  MarketingSubpage,
  MemberCareArticlePage,
  MemberCareCategoryPage,
  MemberCarePage,
  MemberCareSubcategoryPage,
  NotFoundPage,
  PersonalTrainerLandingPage,
  PersonalTrainerSelectSessionPage,
  PersonalTrainerSessionPaymentPage,
  PersonalTrainerSessionShopConfirmationPage,
  PersonalTrainerSessionShopErrorPage,
  Press,
  PressArticle,
  ProfileFilterPage,
  ProfilePage,
  ProfilingQuestionnaireConfirmationPage,
  ProfilingQuestionnairePage,
  Redirect,
  Region,
  ResetPasswordPage,
  SalesPoster,
  SalesPosters,
  SetPasswordPage,
  ShowcasePreview,
  TermsAndConditionsListPage,
  VideoBlockPreview,
  WaitingArea,
  WebAdmin,
  WebAdminContentTypes,
  WebAdminData,
  WebAdminLogin,
  WebAdminSettings,
  WebAdminSitemap,
};
